import "./NirProcessSpectrometers.module.css";
import Header from "@/reusable_sections/Header";
import SpectrometerHero from "./sections/SpectrometerHero";
import Variants from "./sections/Variants";
import Consultation from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";
export default function NirProcessSpectrometersPage() {
  return <div>
      <Header />
      <SpectrometerHero />
      <Variants />
      <Consultation />
      <Footer />
    </div>;
}